"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _exports = babelHelpers.interopRequireDefault(require("exports"));

var _VirtualEventInfo = require("VirtualEventInfo");

var _decorators = require("decorators");

var _react = babelHelpers.interopRequireDefault(require("react"));

var _class, _descriptor, _temp;

var VirtualEventCard = (_class = (_temp =
/*#__PURE__*/
function (_Card$makeDefaultCard) {
  babelHelpers.inherits(VirtualEventCard, _Card$makeDefaultCard);

  function VirtualEventCard() {
    var _babelHelpers$getProt;

    var _this;

    babelHelpers.classCallCheck(this, VirtualEventCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(VirtualEventCard)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this, "event", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this)));
    return _this;
  }

  babelHelpers.createClass(VirtualEventCard, [{
    key: "renderAdditionalTopItems",
    value: function renderAdditionalTopItems() {
      return _react.default.createElement("div", {
        className: "virtualEventInfo date-container center"
      }, _react.default.createElement(_VirtualEventInfo.VirtualEventCardHeader, this.event));
    }
  }, {
    key: "renderTileBody",
    value: function renderTileBody() {
      return _react.default.createElement("div", null, _react.default.createElement(_VirtualEventInfo.VirtualEventCardBody, this.event));
    }
  }, {
    key: "renderBottomContent",
    value: function renderBottomContent() {
      if (this.isPurchaseTile) return babelHelpers.get(babelHelpers.getPrototypeOf(VirtualEventCard.prototype), "renderBottomContent", this).call(this);
      return null;
    }
  }]);
  return VirtualEventCard;
}(_base.default.makeDefaultCardType('virtualEvent', 'Event')), _temp), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class.prototype, "event", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
exports.default = VirtualEventCard;